import { __decorate, __metadata } from "tslib";
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
export var LateFtd;
(function (LateFtd) {
    LateFtd[LateFtd["True"] = 1] = "True";
    LateFtd[LateFtd["False"] = 0] = "False";
})(LateFtd || (LateFtd = {}));
export const LateFtdMap = new Map([
    [LateFtd.True, 'Global.Text.IncludeLate'],
    [LateFtd.False, 'Global.Text.NoLate'],
]);
let LateFtdsService = class LateFtdsService {
    constructor(_translate) {
        this._translate = _translate;
        this._data = LateFtdMap;
    }
    list() {
        return this._data;
    }
    get(key) {
        const k = this._data.get(key);
        return k ? this._translate.instant(k) : k;
    }
};
LateFtdsService.ctorParameters = () => [
    { type: TranslateService }
];
LateFtdsService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [TranslateService])
], LateFtdsService);
export { LateFtdsService };
